import React, { useRef, useState } from 'react';
import {
  Box,
  createStyles,
  InputBase,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    name: {
      textAlign: 'left',
    },
    value: {
      flexGrow: 1,
    },
    icon: {
      height: 15,
      color: '#FF4340',
    },
    button: {
      cursor: 'pointer',
      width: 'fit-content',
    },
    disabled: {
      color: 'black',
    },
    input: {
      padding: theme.spacing(0, 1),
    },
  }),
);

interface Params<T> {
  mutationVariableName?: keyof T;
  name: string;
  value: string | undefined | null;
  editable?: boolean;
  setState?: React.Dispatch<React.SetStateAction<T>>;
}

const CustomDetailItem = <T extends Object>(props: Params<T>) => {
  const { name, value, editable, mutationVariableName, setState } = props;
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(value || '');
  const inputRef = useRef<any>(null);

  const handleFocus = () => {
    setIsEditing(true);
  };

  const setFocused = () => {
    setIsEditing(true);
    if (inputRef && inputRef.current) {
      inputRef?.current?.focus();
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editable && mutationVariableName && setState) {
      setState((prev) => {
        return {
          ...prev,
          [mutationVariableName]: text,
        };
      });
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const inputText = event.target.value;
    setText(inputText);
  };

  React.useEffect(() => {
    setText(value || '');
  }, [value]);

  return (
    <Box className={classes.container}>
      <Typography className={classes.name}>{name} :</Typography>
      <InputBase
        value={editable ? text : value}
        inputRef={inputRef}
        inputProps={{ 'aria-label': 'naked' }}
        disabled={!editable}
        classes={{ disabled: classes.disabled, input: classes.input }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
      />
      {editable && (
        <Box>
          {isEditing ? (
            <SaveIcon className={classes.icon} onClick={handleBlur} />
          ) : (
            <EditIcon className={classes.icon} onClick={setFocused} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default CustomDetailItem;
